import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

import TaskStatusIcon from './TaskStatusIcon';

interface StatusSummaryDisplayProps {
  statusCounts: Array<{
    statusType: ProcessTaskStatusType;
    count: number;
    label?: string;
  }>;
}

/**
 * Renders a status summary; e.g.: "3 Done  2 In progress" (with icons!).
 * This component has no logic. It prints what you tell it.
 */
export default function StatusSummaryDisplay(props: StatusSummaryDisplayProps): JSX.Element {
  return (
    <>
      {props.statusCounts.map(({count, statusType, label}, index) => (
        <span
          className={classNames(
            index < props.statusCounts.length - 1 && 'u-spacing-right',
            css(styles.statusSummary)
          )}
          key={`${statusType}.${label}.${index}`}
          {...getTestProps({
            component: 'StatusSummaryDisplay',
            element: 'taskStatusIcon',
            key: statusType,
          })}
          data-amp-safe={false}
        >
          <TaskStatusIcon type={statusType} /> {count} {label}
        </span>
      ))}
    </>
  );
}

const styles = StyleSheet.create({
  statusSummary: {
    fontSize: '13px',
    display: 'inline-flex',
    alignItems: 'center',
  },
});
